import { Collapse, Grid, MenuItem, TextField } from '@mui/material';
import React, { useMemo } from 'react';
import { staticArrayAsProxy } from '../../../../../Interfaces/IAsProxy';
import { IMemberSignerData } from '../../../../../Interfaces/ILegalTransactionRelationship/Members/IMemberSigner';
import { staticTypeOfIdentificationArray } from '../../../../../Interfaces/ITypeOfIdentification';

interface ISignatureCertificationLegalClientDataEditProps {
  data: IMemberSignerData;
  setData: (data: IMemberSignerData) => void;
}

export const SignatureCertificationLegalClientInformations: React.FC<
  ISignatureCertificationLegalClientDataEditProps
> = ({ data, setData }) => {
  const isFreeTextAsProxy = useMemo(() => {
    return (
      data.asProxy &&
      staticArrayAsProxy.find(x => x.idAsProxy === data.idAsProxy)
        ?.allowFreeText
    );
  }, [data.idAsProxy, data.asProxy]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            select
            fullWidth
            label='Ausweisdokument'
            size='small'
            value={data.idTypeOfDocument || 1}
            required
            onChange={event =>
              setData({
                ...data,
                idTypeOfDocument: Number(event.target.value),
              })
            }
          >
            {staticTypeOfIdentificationArray.map(doc => (
              <MenuItem
                key={`typeofdoc-${doc.idTypeOfDocument}`}
                value={doc.idTypeOfDocument}
              >
                {doc.TypeOfDocument}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <Collapse
            in={
              staticTypeOfIdentificationArray.find(
                x => x.idTypeOfDocument === data.idTypeOfDocument
              )?.allowFreeText
            }
          >
            <TextField
              fullWidth
              label='Ergänzende Informationen zum Ausweisdokument'
              size='small'
              value={data.textTypeOfDocument || ''}
              onChange={event =>
                setData({
                  ...data,
                  textTypeOfDocument: event.target.value,
                })
              }
              required={
                staticTypeOfIdentificationArray.find(
                  x => x.idTypeOfDocument === data.idTypeOfDocument
                )?.allowFreeText
              }
            />
          </Collapse>
        </Grid>
        <Grid item xs={6}>
          <TextField
            label='Als Vetretung von Dritten'
            value={data.asProxy ? 'true' : 'false'}
            onChange={event =>
              setData({
                ...data,
                asProxy: event.target.value === 'true',
              })
            }
            select
            size='small'
            fullWidth
            required
          >
            <MenuItem value='true'>Ja</MenuItem>
            <MenuItem value='false'>Nein</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <Collapse in={data.asProxy === true}>
            <TextField
              label='Vertretungsart'
              value={data.idAsProxy || 1}
              onChange={event =>
                setData({
                  ...data,
                  idAsProxy: Number(event.target.value),
                })
              }
              select
              size='small'
              fullWidth
            >
              {staticArrayAsProxy.map(asProxy => (
                <MenuItem
                  key={`asproxy-${asProxy.idAsProxy}`}
                  value={asProxy.idAsProxy}
                >
                  {asProxy.typeAsProxy}
                </MenuItem>
              ))}
            </TextField>
          </Collapse>
        </Grid>
        <Grid item xs={12}>
          <Collapse in={isFreeTextAsProxy}>
            <TextField
              label='Ergänzende Informationen zur Vertretung'
              value={data.textAsProxy || ''}
              onChange={event =>
                setData({
                  ...data,
                  textAsProxy: event.target.value,
                })
              }
              multiline
              minRows={2}
              required={isFreeTextAsProxy}
              size='small'
              fullWidth
            />
          </Collapse>
        </Grid>
      </Grid>
    </>
  );
};
